export default __webpack_public_path__ + "static/media/trhq-logo.3929646b.png";